"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = (theme, _props, classes) => ({
    chart: {
        width: '100%',
        height: 'calc(100% - 52px)',
    },
    chartLoading: {
        width: '100%',
        height: 'calc(100% - 52px)',
        textAlign: 'center',
        marginTop: 145,
    },
    chartLoadingText: {
        color: theme.palette.text.secondary,
    },
    openRoot: {
        flexShrink: 0,
        backgroundColor: theme.palette.background.paper,
        height: theme.mixins.register.projectedHeightOpen,
        minHeight: 190,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
    },
    customSelect: {
        color: theme.palette.border.dark,
        '&:before': {
            display: 'none',
        },
        '&:after': {
            display: 'none',
        },
    },
    closeRoot: {
        flexShrink: 0,
        height: theme.mixins.register.projectedHeightClosed,
        backgroundColor: theme.palette.background.paper,
        overflow: 'hidden',
    },
    customDropArrow: {
        marginRight: 4,
        color: theme.palette.text.secondary,
    },
    selectLine: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: 68,
        borderBottom: `1px solid ${theme.palette.background.elevated}`,
    },
    modal: {
        width: '100%',
        height: 'calc(100% - 52px)',
        zIndex: 1,
        position: 'absolute',
        top: 52,
        left: 0,
    },
    leftMenu: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        height: 56,
    },
    tooltipCanvas: {
        height: '100%',
        width: '100%',
        position: 'relative',
    },
    selectRoot: {
        fontWeight: theme.typography.fontWeightMedium,
    },
    chipRoot: {
        textAlign: 'center',
        fontSize: 14,
        justifyContent: 'center',
        textOverflow: 'ellipsis',
        color: theme.palette.text.secondary,
        backgroundColor: `${theme.palette.background.elevated} !important`,
    },
    skeletonBlock: {
        backgroundColor: theme.palette.background.elevated,
        height: '170%',
        width: '100%',
        justifyContent: 'center',
        textAlign: 'center',
        borderRadius: 8,
        marginTop: -90,
    },
    skeletonLoadingText: {
        color: theme.palette.text.secondary,
        paddingTop: 100,
    },
    legendsRoot: {
        display: 'flex',
        marginTop: 30,
        justifyContent: 'center',
        [`& .${classes.legendIncome}`]: {
            marginLeft: 0,
        },
    },
    legendLabel: Object.assign(Object.assign({}, theme.typography.subtitle1), { color: theme.palette.text.secondary, userSelect: 'none', marginLeft: 48, '&::before': {
            content: '" "',
            display: 'inline-block',
            borderRadius: '50%',
            width: 13,
            height: 13,
            marginRight: 10,
        } }),
    legendIncome: Object.assign(Object.assign({}, theme.typography.subtitle1), { color: theme.palette.text.secondary, userSelect: 'none', marginLeft: 48, '&::before': {
            content: '" "',
            display: 'inline-block',
            borderRadius: '50%',
            width: 13,
            height: 13,
            marginRight: 10,
            background: theme.palette.legend.income,
        } }),
    legendBill: Object.assign(Object.assign({}, theme.typography.subtitle1), { color: theme.palette.text.secondary, userSelect: 'none', marginLeft: 48, '&::before': {
            content: '" "',
            display: 'inline-block',
            borderRadius: '50%',
            width: 13,
            height: 13,
            marginRight: 10,
            background: theme.palette.legend.bill,
        } }),
    legendRefund: Object.assign(Object.assign({}, theme.typography.subtitle1), { color: theme.palette.text.secondary, userSelect: 'none', marginLeft: 48, '&::before': {
            content: '" "',
            display: 'inline-block',
            borderRadius: '50%',
            width: 13,
            height: 13,
            marginRight: 10,
            background: theme.palette.legend.refund,
        } }),
});
exports.styles = styles;
